import { render, staticRenderFns } from "./ReferencesMedicine.vue?vue&type=template&id=d1dc8ec4"
import script from "./ReferencesMedicine.vue?vue&type=script&lang=js"
export * from "./ReferencesMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports